export default __webpack_public_path__ + "static/partner14-c9e98e7acb778e34dc5fd727ef804860.jpg";